import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { connect } from 'react-redux';
import GridExample from '../tools/EditableTable';
import { Button, Form, FormGroup, FormText, Input, Label, Table } from 'reactstrap';
import { ModuleRegistry } from 'ag-grid-community';
import { CheckboxEditorModule } from 'ag-grid-community';

ModuleRegistry.registerModules([CheckboxEditorModule]); 

class SeparationManager extends Component {
    static displayName = SeparationManager.name;

    constructor(props) {
        super(props)
        this.state = {
            permissionFlag: true,
            tableRerender: 1,
            employeeList: [],
            recordTypeList: [],
            empActive: "DEFAULT",
            bearerVAR: "Bearer " + this.props.reduxData.apiKey,
            recActive: "DEFAULT",
            dateActive: '',
            tableSet: []
        }
        this.testPermission();
    }

    async testPermission() {
        this.props.updateFetchTime()
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            pagepk: "/Separation"
        }
        const response = await fetch('ValidDepartments', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': this.state.bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        this.setState({
            permissionFlag: data
        })
        if (data) {
            this.getEmployees()
            this.getTable()
        }
    }

    async getEmployees() {
        this.props.updateFetchTime()
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk
        }
        const response = await fetch('SeparationGetFormData', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': this.state.bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        this.setState({
            employeeList: data.emp
        })
    }

    async getTable() {
        this.props.updateFetchTime()
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk
        }
        const response = await fetch('SeparationGetList', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': this.state.bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        this.setState({
            tableSet: data
        })
    }

    async getRecordtypes(pcid) {
        this.props.updateFetchTime()
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            pcid: pcid
        }
        const response = await fetch('SeparationGetPersonType', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': this.state.bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        this.setState({
            recordTypeList: data
        })
    }

    async addNew() {

        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            pcid: this.state.empActive,
            type: this.state.recActive,
            date: this.state.dateActive
        }
        const response = await fetch('SeparationAddNew', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': this.state.bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        this.setState({
            empActive: "DEFAULT",
            recActive: "DEFAULT"
        })
        this.getEmployees();
        this.getTable();
        this.setState({
            tableRerender: this.state.tableRerender + 1
        })
    }

    async changeStatus(target) {
        this.props.updateFetchTime()
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            pk: target
        }
        const response = await fetch('SeparationChangeStatus', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': this.state.bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        let toSend2 = {
            userLevel: this.props.reduxData.userInfo.level.pk
        }
        const response2 = await fetch('SeparationGetList', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': this.state.bearerVAR },
            body: JSON.stringify(toSend2)
        })
        const data2 = await response2.json();
        this.setState({
            tableSet: data2
        })
    }

    render() {
        if (this.state.permissionFlag == false) {
            this.props.passNewPage(-1);
        }
        return (<div>
            <Form className="d-flex">
                <FormGroup>
                    <Input type="select" value={this.state.empActive} onChange={(e) => { this.setState({ empActive: e.target.value }); this.getRecordtypes(e.target.value); }}>
                        <option value="DEFAULT" disabled>Select...</option>
                        {this.state.employeeList.map(item => (
                            <option value={item.pcid}>{item.name}</option>
                        ))}
                    </Input>
                </FormGroup>
                &nbsp;
                <FormGroup>
                    <Input type="date" value={this.state.dateActive} onChange={(e) => this.setState({dateActive: e.target.value}) } />
                </FormGroup>
                &nbsp;
                <FormGroup>
                    <Input type="select" value={this.state.recActive} onChange={(e) => this.setState({recActive: e.target.value}) }>
                        <option value="DEFAULT" disabled>Select...</option>
                        {this.state.recordTypeList.map(item => (
                            <option value={item.code}>{item.name}</option>
                        ))}
                    </Input>
                </FormGroup>
                <FormGroup>
                    <Button onClick={() => this.addNew() }>Add</Button>
                </FormGroup>
            </Form>
            <br />
            <span style={{ color: 'red' } }>When changing the status in this table, click once then refresh before determining whether the change took.</span>
            {/*<div style={{ height: 650 }}><GridExample queryToRun={3} key={this.state.tableRerender} rerenderCallback={this.getEmployees.bind(this)} /></div>*/}
            <Table>
                <thead>
                    <tr>
                        <th>PK</th>
                        <th>PCID</th>
                        <th>Name</th>
                        <th>Date</th>
                        <th>Type Code</th>
                        <th>Type Name</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    {this.state.tableSet.map(item => (
                        <tr>
                            <td>{item.pk}</td>
                            <td>{item.pcid}</td>
                            <td>{item.name}</td>
                            <td>{item.sepdate}</td>
                            <td>{item.rectype}</td>
                            <td>{item.typename}</td>
                            <td><Input type="select" defaultValue="default" onChange={(e) => this.changeStatus(item.pk)}>
                                {item.status != ""  && item.pk != "" && <option value="switch">Ready to Separate</option>}
                                {item.status != "" && item.pk != "" && <option value="default" disabled>Do Not Separate</option>}
                                {item.status == "" && item.pk != "" && <option value="default" disabled>Ready to Separate</option>}
                                {item.status == "" && item.pk != "" && <option value="switch">Do Not Separate</option>}
                            </Input></td>
                        </tr>
                        
                    ))}
                </tbody>
            </Table>
        </div>)
    }
}

const mapStateTo = state => ({
    reduxData: state
})

const mapDispatchTo = (dispatch) => {
    return {
        updateFetchTime: () => dispatch({ type: 'foundation/setFetchTime' })
    }
}

export default connect(mapStateTo, mapDispatchTo)(SeparationManager);